import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    height: 'fit-content',
    overflow: 'hidden unset'
  },

  noData: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60px',
    color: theme.palette.textLightFaded,
    fontSize: theme.size.lg
  },

  dataRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  icon: {
    marginRight: '0.5rem',
    width: '32px',
    height: '32px'
  },

  expiration: {
    opacity: '0.35',
    fontStyle: 'italic'
  }
}))

export default useStyles
